var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Page", {
        attrs: { title: _vm.pageTitle, isFullWidth: true },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function() {
              return [
                _c(
                  "div",
                  { staticClass: "flex flex-col max-w-xl mx-auto my-10" },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8"
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "divide-y divide-gray-200 overflow-hidden rounded-lg bg-white shadow"
                          },
                          [
                            _c("div", { staticClass: "px-4 py-5 sm:px-6" }, [
                              _c(
                                "legend",
                                {
                                  staticClass:
                                    "text-sm font-semibold leading-6 text-gray-900"
                                },
                                [_vm._v(" Prompt ")]
                              ),
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "mt-1 text-sm leading-6 text-gray-600"
                                },
                                [
                                  _vm._v(
                                    " Configure the opt-in prompt shown for your store visitors. "
                                  )
                                ]
                              )
                            ]),
                            _c("div", { staticClass: "px-4 py-5 sm:p-6" }, [
                              _c("fieldset", [
                                _c("div", { staticClass: "mt-6 space-y-6" }, [
                                  _c(
                                    "div",
                                    { staticClass: "relative flex gap-x-3" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "flex h-6 items-center"
                                        },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.widgetConfig.promptType,
                                                expression:
                                                  "widgetConfig.promptType"
                                              }
                                            ],
                                            staticClass:
                                              "h-4 w-4 border-gray-300 text-indigo-600 focus:ring-indigo-600",
                                            attrs: {
                                              id: "browserPrompt",
                                              name: "push-notifications",
                                              value: "browser",
                                              type: "radio"
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.widgetConfig.promptType,
                                                "browser"
                                              )
                                            },
                                            on: {
                                              input: _vm.updateOptinConfig,
                                              change: function($event) {
                                                return _vm.$set(
                                                  _vm.widgetConfig,
                                                  "promptType",
                                                  "browser"
                                                )
                                              }
                                            }
                                          })
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "text-sm leading-6" },
                                        [
                                          _c(
                                            "label",
                                            {
                                              staticClass:
                                                "font-medium text-gray-900",
                                              attrs: { for: "browserPrompt" }
                                            },
                                            [_vm._v("Browser prompt")]
                                          ),
                                          _c(
                                            "p",
                                            { staticClass: "text-gray-500" },
                                            [
                                              _vm._v(
                                                " Use the default browser optin panel "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "relative flex gap-x-3" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "flex h-6 items-center"
                                        },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.widgetConfig.promptType,
                                                expression:
                                                  "widgetConfig.promptType"
                                              }
                                            ],
                                            staticClass:
                                              "h-4 w-4 border-gray-300 text-indigo-600 focus:ring-indigo-600",
                                            attrs: {
                                              id: "customPrompt",
                                              name: "push-notifications",
                                              value: "custom",
                                              type: "radio"
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.widgetConfig.promptType,
                                                "custom"
                                              )
                                            },
                                            on: {
                                              input: _vm.updateOptinConfig,
                                              change: function($event) {
                                                return _vm.$set(
                                                  _vm.widgetConfig,
                                                  "promptType",
                                                  "custom"
                                                )
                                              }
                                            }
                                          })
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "text-sm leading-6" },
                                        [
                                          _c(
                                            "label",
                                            {
                                              staticClass:
                                                "font-medium text-gray-900",
                                              attrs: { for: "customPrompt" }
                                            },
                                            [
                                              _vm._v("Custom Prompt "),
                                              _c(
                                                "button",
                                                {
                                                  staticClass: "Polaris-Button",
                                                  attrs: { type: "button" },
                                                  on: {
                                                    click: _vm.gotoEditCustom
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "Polaris-Button__Content"
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "Polaris-Button__Text"
                                                        },
                                                        [_vm._v("Edit")]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _c(
                                            "p",
                                            { staticClass: "text-gray-500" },
                                            [
                                              _vm._v(
                                                " Use the Customized optin panel "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "relative flex gap-x-3" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "flex h-6 items-center"
                                        },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.widgetConfig.promptType,
                                                expression:
                                                  "widgetConfig.promptType"
                                              }
                                            ],
                                            staticClass:
                                              "h-4 w-4 border-gray-300 text-indigo-600 focus:ring-indigo-600",
                                            attrs: {
                                              id: "noPrompt",
                                              name: "push-notifications",
                                              value: "none",
                                              type: "radio"
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.widgetConfig.promptType,
                                                "none"
                                              )
                                            },
                                            on: {
                                              input: _vm.updateOptinConfig,
                                              change: function($event) {
                                                return _vm.$set(
                                                  _vm.widgetConfig,
                                                  "promptType",
                                                  "none"
                                                )
                                              }
                                            }
                                          })
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "text-sm leading-6" },
                                        [
                                          _c(
                                            "label",
                                            {
                                              staticClass:
                                                "font-medium text-gray-900",
                                              attrs: { for: "noPrompt" }
                                            },
                                            [_vm._v("No Prompt")]
                                          ),
                                          _c(
                                            "p",
                                            { staticClass: "text-gray-500" },
                                            [
                                              _vm._v(
                                                " Optin prompt won’t be shown to your store visitors. "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ])
                              ])
                            ])
                          ]
                        )
                      ]
                    )
                  ]
                )
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }